module.exports.SHOW_DEBUG_MESSAGES = true;
module.exports.BUILD_REAL_SERVER = false;